declare module "grecaptcha" {
    global {
        interface Window {
            recaptcha_callback: (token: string) => void,
            recaptcha_onload: () => void
        }
    }
}

(function (window, document, $) {
    const buttons = document.getElementsByClassName('g-recaptcha-btn') as HTMLCollectionOf<HTMLButtonElement>;

    let button: HTMLButtonElement | null = null;

    function recaptcha_submit() {
        const form = button!.form!;
        form.classList.add('was-validated');

        const validator = $ && $.fn.validate! && $(form).validate();

        if (form.checkValidity() === false || (validator && validator.valid() === false)) {
            validator.form();
        } else {
            grecaptcha.execute();
        }
    }

    window.recaptcha_callback = function () {
        button!.innerHTML = '<i class="fas fa-fw fa-circle-notch fa-spin"></i>';
        button!.disabled = true;
        button!.form!.submit();
    };

    window.recaptcha_onload = function () {
        for (let i = 0; i < buttons.length; i++) {
            const btn = buttons[i];
            btn.disabled = false;
            btn.form!.onsubmit = function (e) {
                button = btn;
                recaptcha_submit();
                e.preventDefault();
                return false;
            }
        }
    }

    for (let i = 0; i < buttons.length; i++) {
        buttons[i].form!.dataset.disableOnSubmit = 'off';
    }
})(window, document, $);